module.exports = __webpack_public_path__ + "static/media/ic-study-hub.dce8f76c.svg";